import { FC, useState } from 'react';
import { Button, Checkbox, Form, Input, Typography, notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { LoginRequest, useLoginMutation } from '../../services/AuthService';
import { authSlice } from '../../store/reducers/AuthSlice';
import { useAppDispatch } from '../../store/store';
import { invalidatePendingTokenRefreshes } from '../../utils/http/authSession';
import styles from './style.module.css';

export const { Title } = Typography;

const Login: FC = () => {
  const [login, { isLoading }] = useLoginMutation();
  const [rememberMe, setRememberMe] = useState(false);
  const { setCredentials } = authSlice.actions;
  const [api, contextHolder] = notification.useNotification();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleSubmit = async ({ userName, password }: LoginRequest) => {
    try {
      const userData = await login({ userName, password }).unwrap();
      invalidatePendingTokenRefreshes();
      dispatch(setCredentials({ response: userData, rememberMe: rememberMe }));
      navigate('/');
    } catch {
      api.error({
        message: 'Не удалось войти. Обратитесь к администратору.',
      });
    }
  };

  return (
    <div className={styles.auth}>
      {contextHolder}
      <Title level={1} className={styles.title}>
        Вход в аккаунт
      </Title>
      <Form
        className={styles.formRegister}
        name="login"
        layout="vertical"
        autoComplete="off"
        style={{ width: '100%' }}
        onFinish={({ userName, password }: LoginRequest) =>
          handleSubmit({ userName, password })
        }
      >
        <Form.Item
          label="Логин"
          name="userName"
          rules={[
            { required: true, message: 'Введите логин' },
            { whitespace: true },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Пароль"
          name="password"
          rules={[{ required: true, message: 'Введите пароль' }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <label className={styles.formItem}>Запомнить меня</label>
          <Checkbox
            checked={rememberMe}
            onChange={() => setRememberMe(!rememberMe)}
          />
        </Form.Item>

        <Form.Item>
          <Button block type="primary" htmlType="submit" loading={isLoading}>
            Войти
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Login;
